import React from 'react';
import { ITextMessage } from '../../../client/message/types';
import { Box, Typography } from '@mui/material';

interface TextMessageProps {
  message: ITextMessage;
  className?: string;
}

export const TextMessage = ({ message, className = '' }: TextMessageProps) => {
  return (
    <Box className={`text-message ${className}`}>
      <Typography variant="body1">
        {message.content.body}
      </Typography>
    </Box>
  );
}
